const initState = {};

export default function confirmEmailReducer(state = initState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
